import React from 'react';
import styled from 'styled-components';
import { Authenticator } from './auth/Authenticator';
import { RoundLogo } from './branding/RoundLogo';
import { Title } from './components/Title';

const LoginWrapper = styled.div`
   display: flex;
   align-items: center;
   justify-content: center;

   & > div {
      padding: 1.5em;
      max-width: 25em;
   }

   .login-logo {
      display: none;
      margin: 0 auto 2em;
      width: 125px;
      position: relative;
   }

   @media (min-height: 600px) {
      min-height: 70vh;
      .login-logo {
         display: block;
      }
   }
`;

const LogInScreen = () => (
   <>
      <Title title="Log In" />
      <LoginWrapper>
         <div>
            <RoundLogo className="login-logo" />
            <Authenticator />
         </div>
      </LoginWrapper>
   </>
);

export { LogInScreen };
